import { Volume } from '@/api/type-server'
import { Image } from '@/models/image'
import { Machine } from '@/models/machine'
import { Snapshot } from '@/models/snapshot'
import { VOLUME_TYPE } from '@/models/volume'

export function buildCreateInstancePayload({
  machine,
  count,
  checkedImage,
  checkedSnap,
  mountVolume,
  mountPath,
  readWriteMode,
  boundNAT,
  remark,
}: {
  machine: Machine
  count: number
  checkedImage?: Image
  checkedSnap?: Snapshot
  mountVolume?: Volume
  mountPath: string
  readWriteMode: boolean
  boundNAT: any
  remark?: string
}) {
  return {
    auto_password: true,
    hardware_qty: count,
    image_id: checkedImage?.id,
    from_snapshot_id: checkedSnap?.id,
    machine_category: machine.machineCategory,
    mount_infos: JSON.stringify(
      mountVolume
        ? [
            {
              source: '/',
              dest: mountPath,
              readOnly: readWriteMode,
              domain: mountVolume?.domain ?? 0,
            },
          ]
        : [],
    ),
    vnc_switcher: true,
    resource_desc: JSON.stringify({
      agentDomains: machine.domains,
      attributeTags: 1,
      machineClassTag: machine.unitSpec?.classTag,
      unitQty: count,
      gpuName: machine.unitSpec?.gpuName,
      cpuName: machine.unitSpec?.cpuName,
    }),
    vnc_support: checkedImage?.supportVnc ?? false,
    remark,
    nat_res_id: boundNAT?.resID,
  }
}

export function filterValidVolumes(volumes: Volume[], domains: number[] = []): Volume[] {
  const filteredVolumes = volumes.filter((volume) => {
    if (volume.type === VOLUME_TYPE.SNAPSHOT) {
      return false
    }

    if (!domains.includes(volume.domain)) {
      return false
    }

    if (volume.quota_gb === 0 && volume.usage_mb === 0) {
      return false
    }

    return true
  })

  return filteredVolumes
}
